export const siteData = {
  name: "Tak For Din Indsats",
  tagline: "Vi yder sikkerhedsnettet for dem, der passer på Danmark.",
  logo: "https://assets.auxodev.dk/assets/512cb13c-28f0-4ecb-9d9d-4ac03cf77200/e3f2cbcb-4e69-4564-bc36-49deffe54d44.gif",
  contact: {
    emails: ["info@takfordinindsats.dk", "behandling@takfordinindsats.dk"],
    phone: "+45 12 34 56 78",
    address: "Danmark",
    cvr: "44823616"
  },
  socials: {
    facebook: "https://facebook.com/takfordinindsats",
    instagram: "https://instagram.com/takfordinindsats",
    linkedin: "https://linkedin.com/company/takfordinindsats",
    youtube: "https://youtube.com/@takfordinindsats"
  },
  navigation: [
    { name: "FORSIDE", href: "/" },
    { name: "Brug for hjælp", href: "/kontakt#soeg-hjaelp" },
    { name: "Om os", href: "/om-os" },
    { name: "Sponsorer", href: "/sponsorer" },
    { name: "Samarbejde", href: "/samarbejde" },
    { name: "TFDI på nettet", href: "/tfdi-paa-nettet" },
    { name: "Nyheder/Events", href: "/nyheder" },
    { name: "Webinar", href: "https://webinar.takfordinindsats.dk", external: true },
    { name: "Støt os", href: "/stoet-os" },
    { name: "Kontakt", href: "/kontakt" }
  ],
  hero: {
    title: "TAK FOR DIN INDSATS",
    description: "Vi er en frivillig forening, som hjælper alt frontpersonale der arbejder for Danmark.",
    ctaPrimary: { text: "Doner nu", href: "/stoet-os" },
    ctaSecondary: { text: "Bliv medlem", href: "https://tilmeld.takfordinindsats.dk/signup" },
    images: [
      "https://assets.auxodev.dk/assets/512cb13c-28f0-4ecb-9d9d-4ac03cf77200/0cc534b9-4aac-4e9a-a66e-6b869f806ed4.png",
      "https://assets.auxodev.dk/assets/512cb13c-28f0-4ecb-9d9d-4ac03cf77200/252ea30d-f218-4d6f-a97a-9632b4ff1742.png",
      "https://assets.auxodev.dk/assets/512cb13c-28f0-4ecb-9d9d-4ac03cf77200/1cf26a57-9953-42c0-917b-57501063a6d7.jpg"
    ]
  },
  vision: {
    title: "Rådgivning og vejledning når livet er svært",
    content: [
      "Vi tilbyder professionel rådgivning og vejledning til mennesker der står i svære livssituationer.",
      "Gennem samtaler, praktisk hjælp og vejledning gennem systemet støtter vi dig i at finde løsninger og komme videre i livet.",
      "TFDI tilbyder mentor ordning, hvor kollegaer kan få vejledning og støtte."
    ],
    image: "https://assets.auxodev.dk/assets/512cb13c-28f0-4ecb-9d9d-4ac03cf77200/85b1d455-631f-4f4e-9933-4d9338d439a7.png"
  },
  support: {
    title: "Støt dem, der passer på os",
    description: "Hver en krone tæller. Da alt arbejde er frivilligt, går din støtte direkte til sikkerhedsnettet for vores frontpersonale.",
    mobilePay: "https://assets.auxodev.dk/assets/512cb13c-28f0-4ecb-9d9d-4ac03cf77200/7d457f6b-a853-4468-801c-069ccbf122fb.png",
    bank: {
      reg: "1234",
      account: "123456789"
    }
  },
  whoWeHelp: [
    { name: "Forsvar", icon: "Shield" },
    { name: "Politi", icon: "Siren" },
    { name: "Sygehus", icon: "HeartPulse" },
    { name: "Fængsel", icon: "Lock" },
    { name: "Brand/Redning", icon: "Flame" },
    { name: "Ambulance", icon: "Ambulance" }
  ],
  documents: [
    {
      name: "Udtalelse fra Udenrigsministeriet",
      description: "Officiel udtalelse og godkendelse fra Udenrigsministeriet vedrørende foreningens arbejde og formål.",
      type: "Billede",
      size: "1.2 MB",
      url: "https://assets.auxodev.dk/assets/512cb13c-28f0-4ecb-9d9d-4ac03cf77200/um-2024-1.png"
    },
    {
      name: "TFDI - Generalforsamling 3. juni 2026 - Referat",
      description: "Det officielle referat fra foreningens ordinære generalforsamling afholdt den 3. juni 2026.",
      type: "PDF",
      size: "185 KB",
      url: "https://assets.auxodev.dk/assets/512cb13c-28f0-4ecb-9d9d-4ac03cf77200/tfdi-generalforsamling-3-juni-2026-referat.pdf"
    },
    {
      name: "TFDI - Generalforsamling 3. juni 2026 - Indkaldelse",
      description: "Den officielle indkaldelse og dagsorden til foreningens ordinære generalforsamling den 3. juni 2026.",
      type: "PDF",
      size: "142 KB",
      url: "https://assets.auxodev.dk/assets/512cb13c-28f0-4ecb-9d9d-4ac03cf77200/tfdi-generalforsamling-3-juni-2026-indkaldelse.pdf"
    },
    {
      name: "TFDI - Årsrapport 2025",
      description: "Foreningens årsrapport for regnskabsåret 2025, som beskriver vores aktiviteter, indsatser og økonomiske resultater.",
      type: "PDF",
      size: "2.1 MB",
      url: "https://assets.auxodev.dk/assets/512cb13c-28f0-4ecb-9d9d-4ac03cf77200/tfdi-aarsrapport-2025.pdf"
    },
    {
      name: "TFDI - Generalforsamling 26. maj 2025 - Referat",
      description: "Det officielle referat fra foreningens ordinære generalforsamling afholdt den 26. maj 2025.",
      type: "PDF",
      size: "176 KB",
      url: "https://assets.auxodev.dk/assets/512cb13c-28f0-4ecb-9d9d-4ac03cf77200/tfdi-generalforsamling-26-maj-2025-referat.pdf"
    },
    {
      name: "TFDI - Generalforsamling 26. maj 2025 - Indkaldelse",
      description: "Den officielle indkaldelse og dagsorden til foreningens ordinære generalforsamling den 26. maj 2025.",
      type: "PDF",
      size: "135 KB",
      url: "https://assets.auxodev.dk/assets/512cb13c-28f0-4ecb-9d9d-4ac03cf77200/tfdi-generalforsamling-26-maj-2025-indkaldelse.pdf"
    },
    {
      name: "TFDI - Indsamlingsregnskab 2024-2025",
      description: "Det officielle og godkendte regnskab for foreningens indsamlingsaktiviteter i perioden 2024 til 2025.",
      type: "PDF",
      size: "1.4 MB",
      url: "https://assets.auxodev.dk/assets/512cb13c-28f0-4ecb-9d9d-4ac03cf77200/tdfi-indsamlingsregnskab-2024-2025.pdf"
    },
    {
      name: "TFDI - Årsrapport 2024",
      description: "Foreningens årsrapport for regnskabsåret 2024, som beskriver foreningens opstart, indsatser og økonomi.",
      type: "PDF",
      size: "1.8 MB",
      url: "https://assets.auxodev.dk/assets/512cb13c-28f0-4ecb-9d9d-4ac03cf77200/tfdi-aarsrapport-2024.pdf"
    },
    {
      name: "TFDI - Eks Generalforsamling 12. august 2024 - Referat",
      description: "Det officielle referat fra foreningens ekstraordinære generalforsamling afholdt den 12. august 2024.",
      type: "PDF",
      size: "165 KB",
      url: "https://assets.auxodev.dk/assets/512cb13c-28f0-4ecb-9d9d-4ac03cf77200/tfdi-eks-generalforsamling-12-august-2024-referat.pdf"
    },
    {
      name: "TFDI - Eks Generalforsamling 12. august 2024 - Indkaldelse",
      description: "Den officielle indkaldelse til foreningens ekstraordinære generalforsamling den 12. august 2024.",
      type: "PDF",
      size: "120 KB",
      url: "https://assets.auxodev.dk/assets/512cb13c-28f0-4ecb-9d9d-4ac03cf77200/tfdi-eks-generalforsamling-12-august-2024-indkaldelse.pdf"
    },
    {
      name: "TFDI - Vedtægter 12. august 2024",
      description: "Foreningens gældende og godkendte vedtægter, opdateret og vedtaget på den ekstraordinære generalforsamling den 12. august 2024.",
      type: "PDF",
      size: "245 KB",
      url: "https://assets.auxodev.dk/assets/512cb13c-28f0-4ecb-9d9d-4ac03cf77200/tfdi-vedtaegter-12-august-2024.pdf"
    },
    {
      name: "TFDI - Generalforsamling 7. juli 2024 - Referat",
      description: "Det officielle referat fra foreningens ordinære generalforsamling afholdt den 7. juli 2024.",
      type: "PDF",
      size: "170 KB",
      url: "https://assets.auxodev.dk/assets/512cb13c-28f0-4ecb-9d9d-4ac03cf77200/tfdi-generalforsamling-7-juli-2024-referat.pdf"
    },
    {
      name: "TFDI - Generalforsamling 7. juli 2024 - Indkaldelse",
      description: "Den officielle indkaldelse og dagsorden til foreningens ordinære generalforsamling den 7. juli 2024.",
      type: "PDF",
      size: "130 KB",
      url: "https://assets.auxodev.dk/assets/512cb13c-28f0-4ecb-9d9d-4ac03cf77200/tfdi-generalforsamling-7-juli-2024-indkaldelse.pdf"
    },
    {
      name: "TFDI - Stif Generalforsamling 8. maj 2024 - Referat",
      description: "Det officielle referat fra foreningens stiftende generalforsamling afholdt den 8. maj 2024.",
      type: "PDF",
      size: "160 KB",
      url: "https://assets.auxodev.dk/assets/512cb13c-28f0-4ecb-9d9d-4ac03cf77200/tfdi-stif-generalforsamling-8-maj-2024-referat.pdf"
    },
    {
      name: "TFDI - Stif Generalforsamling 8. maj 2024 - Indkaldelse",
      description: "Den officielle indkaldelse til foreningens stiftende generalforsamling den 8. maj 2024.",
      type: "PDF",
      size: "115 KB",
      url: "https://assets.auxodev.dk/assets/512cb13c-28f0-4ecb-9d9d-4ac03cf77200/tfdi-stif-generalforsamling-8-maj-2024-indkaldelse.pdf"
    },
    {
      name: "TFDI - Vedtægter 8. maj 2024",
      description: "Foreningens oprindelige vedtægter, vedtaget ved den stiftende generalforsamling den 8. maj 2024.",
      type: "PDF",
      size: "230 KB",
      url: "https://assets.auxodev.dk/assets/512cb13c-28f0-4ecb-9d9d-4ac03cf77200/tfdi-vedtaegter-8-maj-2024.pdf"
    }
  ],
  bestyrelse: [
    {
      name: "Morten Aagaard",
      role: "Formand",
      email: "morten@takfordinindsats.dk",
      bio: "Jeg er gået ind i bestyrelsen hos Tak for din indsats, fordi der er brug for forandring. Alt for længe har vi i beredskabet båret de psykiske belastninger af vores arbejde – ofte alene og i stilhed. Vi træder ind, når andres verden falder sammen. Vi gør det med professionalisme, hjerte og handlekraft. Men virkeligheden er, at de oplevelser, vi står i, sætter spor. Og for mange af os bliver de spor til noget tungt, vi ikke får talt om, ikke får hjælp til – og ikke bliver mødt i. Jeg mener, at vi har brug for en mere helhedsorienteret indsats. En kultur og et system, hvor det ikke er et svaghedstegn at blive påvirket – men en menneskelig reaktion på et umenneskeligt pres. Det handler ikke om at fjerne det svære – for det er en del af jobbet. Men det handler om, at ingen skal stå alene med det. At vi bliver mødt – både som fagpersoner og som mennesker. Jeg håber at kunne bruge min erfaring og stemme til at skabe mere åbenhed, forståelse og reel forandring. Det skylder vi hinanden. Med 30 år i beredskabet, hvor jeg har arbejdet i mange funktioner – og som paramediciner siden 2009 – har jeg et indgående kendskab til kollegaer i alle dele af beredskabet. De seneste tre år har jeg desuden været en del af Lundbeckfondens bestyrelse og Falcks bestyrelse, og jeg vil bruge min erfaring fra disse sammenhænge til at styrke arbejdet i Tak for din indsats. Vi har brug for handling. Vi har brug for systematisk støtte. Og vi har brug for, at det er okay ikke at være okay."
    },
    {
      name: "Paul Carlsen",
      role: "Næstformand",
      email: "paul@takfordinindsats.dk",
      bio: "“Jeg er 62 år og svagstrømstekniker i Aalborg Kommune. Jeg har arbejdet inden for flere af de fag, der kan blive berørt, herunder Brand og Redning, og jeg har adskillige kolleger, både nuværende og tidligere, der er blevet påvirket i større eller mindre grad. Jeg har også en fortid i Forsvaret og kender derfor til de problematikker, der kan opstå der. Samtidig er jeg far til Steffen, der lider af kompleks PTSD, og jeg har fulgt hans kamp gennem de seneste år.\n\nJeg har stået ved Steffens side og set, hvordan en helhedsorienteret behandlingsindsats har reddet hans liv, da det var allerværst, og fortsat støtter ham, trods systemet ikke kan hjælpe mere. Derfor ønsker jeg at bidrage til foreningens arbejde.”"
    },
    {
      name: "Kamilla Bittmann",
      role: "Bestyrelsesmedlem",
      email: "kamilla@takfordinindsats.dk",
      bio: "”Jeg er uddannet officer fra Hæren og har over 20 års erfaring fra forsvaret. Jeg har været udsendt og har mange veteraner i mit netværk. Jeg er selv gift med en soldat/veteran og ved, hvilke udfordringer der ligger, dels som udsendt, men også som pårørende. Jeg har seen, hvor mange veteraner ikke får den fornødne hjælp, og det vil jeg gerne være med til at gøre noget ved. I dag er jeg reserveofficer og har stadig en stærk tilknytning til forsvaret. Jeg er ikke længere selv ansat på fuld tid i forsvaret, men er direktør i Erhverv Norddanmark, der er en nordjysk erhvervsorganisation, hvilket giver mig et stort netværk og kontakter. Jeg håber at kunne bidrage med i arbejdet i bestyrelsesarbejdet i ”Tak for din indsats”. ”"
    },
    {
      name: "Steffen Carlsen",
      role: "Bestyrelsesmedlem",
      bio: "”Som frivillig hos Tak For Din Indsats (TFDI) bidrager jeg med førstehåndsindtryk og beretninger om hvor vi i Danmark stadigvæk kan blive bedre til at hjælpe vores Danske helte. Jeg er så heldig at gode mennesker et gået sammen omkring mig og vil gøre en forskel for mig og mine skadede kollegaer blandt veteraner, frontpersonale (Forsvar, Politi, Fængsel, Brand, Redning og Sygehus) og deres pårørende, børn og familie.\n\nEfter mere end 11 år som operativ jægersoldat ramte jeg muren og 17 år forsvaret. Med symptomerne hængene over mig i mere end 6 år kunne jeg desværre ikke mere. Det gik stærkt, alt for stærkt. 27 måneder fra operativ jægersoldat etil førtidspensionist med tre diagnoser. Svær PTSD/K-PTSD, personlighedsændring efter katastrofeoplevelse og periodisk depression. At pludselig skulle se fjenden i mit eget spejlbillede, bange ude af stand til at gøre noget. Boet otte måneder på et PTSD bosted, erklæret medicinsk og traumeterapeutisk ude af stand til at blive behandlet af Specialisterne i Skejby, er vejen igennem mørket svær. Jeg befinder mig nu i trygge og stabile rammer og skal forsat arbejde på et bedre liv for mine to drenge og jeg. Med TFDI tror jeg på at den rigtige helhedsorienteret behandlingsindsats kan findes via at samle internationale erfaringer, dele denne viden og ved donationer og støtte, viderebringe denne til dem som mest mangler det, INDEN DET ER FOR SENT!”\n\n“Styrken til at forsætte, håb til at leve”"
    },
    {
      name: "Jens Jakob Riis",
      role: "Bestyrelsesmedlem",
      bio: "Jens Jakob Riis (f. 1973), læge 2001 og speciallæge i neurokirurgi 2009.\n\n”Jeg har været tilknyttet Forsvaret som Reaktionsstyrkelæge siden 2015, udsendt til Mali i 2016 og har både før og efter denne udsendelse mødt mænd og kvinder, der gennem deres arbejde er blevet ramt af PTSD. Deraf er jeg blevet bekendt med de konsekvenser, det kan have både økonomisk, personligt, jobmæssigt og socialt. Det vakte interessen hos mig, og der er gennem tiderne, bl.a. med baggrund i erfaringerne fra USA, udviklet nye behandlinger, der ser meget lovende ud så fremtidens PTSD-ramte kan få en endnu bedre behandling, end den der tilbydes i dag. Med min faglige baggrund kan jeg bidrage til, gennem bl.a. mit netværk, at vi får testet og evt. implementeret disse behandlinger, således  at vi får de PTSD- ramte ud meget bedre i den anden ende, end tilfældet er i dag. Det er mit store håb, at TFDI kan levere væsentlige fingeraftryk og bidrag til fremtidens behandling af PTSD.”"
    },
    {
      name: "Thorkild Fuglsang",
      role: "Bestyrelsesmedlem",
      bio: "Jeg var ansat i forsvaret fra 1992 til 2002, hvor jeg havde to udsendelser to Kroatien, to til Kosovo og to til Afghanistan. Afghanistans støv blev i 2002 udskiftet med røde færdselsbøger på politiskolen, hvor den blå uniform efterfølgende var arbejdspladsen i 18 år. Jeg startede i forsvarsindustrien i 2020 hvor jeg stadig befinder mig. Efter at været faldet til ro og fået tid til at se mig tilbage, har jeg et ønske om at give tilbage og hjælpe dem, der ikke selv er kommet igennem svære episoder lige så godt, som mig selv. Der er sket rigtigt meget igennem de sidste 30 år, men vi kan og skal stadig tilbyde mere og bedre hjælp. Jeg elsker at være i naturen på vandre- og shelterture og rejse til ødemarken i Canada og Alaska med mit kamera."
    },

    {
      name: "Martin Langemose",
      role: "Bestyrelsesmedlem",
      bio: "Jeg er trådt ind i bestyrelsen i foreningen Tak For Din Indsats, for at bidrage til, at sætte retning og fokus på PTSD for frontpersonale. Som tillidsrepræsentant i beredskabet og formand for det faglige udvalg i FOA Brand og Redning, så oplever jeg oftere og oftere snakken om PTSD. En undersøgelse for et par år siden viste, at der var flere i risikogruppen for at udvikle PTSD, men hvad sker der egentlig med dem som er eller bliver ramt.? Kan vi gøre noget for dem? Her er foreningen Tak For Din Indsats en god samarbejdspartner for frontpersonale i forsvaret, beredskabet, politiet eller kriminalforsorgen, hvor man som ramt individ eller som familie kan søge hjælp. Vi kan ikke redde alle, men alle kan få muligheden, når vi siger Tak For Din Indsats.! Jeg vil arbejde for at foreningen kommer bredt ud og bidrage med min viden, erfaring og netværk."
    },
    {
      name: "Kevin Kappel",
      role: "Bestyrelsesmedlem",
      bio: "“Som tidligere soldat og veteran har jeg stor respekt og indsigt i de vilkår, som frontpersonale arbejder under. Jeg mener at de mennesker, som har behov for hjælp og støtte, skal modtage denne og det vil jeg gerne bidrage til. Det er derfor naturligt for mig at engagere mig i TakForDinIndsats. Jeg er særligt glad for, at foreningen hjælper frontpersonalets alle faggrupper herunder både nuværende og tidligere ansatte fra brand/redning, fængselsbetjenter, politiet, sygehus og Forsvaret. Arbejdsrelaterede belastningsreaktioner fysisk, psykisk og kognitivt, skelner nemlig ikke mellem hvilket erhverv man har haft, eller hvilken uniform man har båret – og derfor skal støtten heller ikke. Jeg håber at kunne bidrage med både erfaring og engagement og være med til at styrke det vigtige arbejde, som TFDI already gør.”"
    }
  ],
  frivillige: [
    "Dennis Andersen",
    "Tommi Hansen",
    "Thomas Ingemann Nielsen",
    "Jan Tørning",
    "Daniel Andersen",
    "Tore Binderup",
    "Vibeke Wesenberg",
    "Cecilie Egholm Aagaard"
  ],
  forretningsudvalg: [
    {
      name: "Maja Torp",
      role: "Forperson"
    }
  ],
  onTheWeb: [
    {
      id: "vellykket-sgb-behandling-2026",
      title: "Vellykket SGB behandling 8. sep 2026",
      titleLines: [
        "Vellykket SGB behandling 8. sep 2026",
        "Slået op på FB Veteranhjem Aalborg – Støttegruppe"
      ],
      source: "FB Veteranhjem Aalborg – Støttegruppe",
      date: "8. sep 2026",
      category: "Artikler & Nyheder",
      image: "https://assets.auxodev.dk/assets/512cb13c-28f0-4ecb-9d9d-4ac03cf77200/tfdi-billede.png",
      imageAlt: "Vellykket SGB behandling 8. sep 2026 - Slået op på FB Veteranhjem Aalborg – Støttegruppe",
      hasNoLink: true
    },
    {
      id: "erhverv-norddanmark-2026",
      title: "Erhverv Nord Danmark – TFDI taler til generalforsamling",
      source: "Erhverv Norddanmark",
      date: "Marts 2026",
      linkText: "Tak for din indsats med Steffen Carlsen... - Tak For Din Indsats | Facebook",
      url: "https://www.facebook.com/takfordinindsats",
      category: "Artikler & Nyheder",
      description: "Steffen Carlsen holdt et gribende og vigtigt oplæg til Erhverv Nord Danmarks generalforsamling om vigtigheden af at støtte vores frontpersonale og skabe stærke netværk på tværs af erhvervslivet."
    },
    {
      id: "foa-steffen-front-2025",
      title: "FOA: Steffen knækkede efter årevis i front",
      source: "FOA",
      date: "December 2025",
      linkText: "Steffen knækkede efter årevis i front: Nu kræver han bedre vilkår for dem, der hjælper andre",
      url: "https://www.foa.dk/",
      category: "Artikler & Nyheder",
      description: "Et dybdegående og personligt interview med Steffen Carlsen i FOA-bladet om hans kamp mod PTSD efter 17 år i Forsvaret, og hvorfor det nuværende system svigter vores helte."
    },
    {
      id: "flagdagen-loekke-2025",
      title: "Flagdagen - Det er ikke kun i krig, man kan falde. Lars Løkke Rasmussen",
      source: "Flagdagen.dk",
      date: "September 2025",
      linkText: "Det er ikke kun i krig, man kan falde - Flagdagen.dk",
      url: "https://flagdagen.dk/",
      category: "Artikler & Nyheder",
      description: "En stærk markering af Flagdagen, hvor udenrigsminister Lars Løkke Rasmussen understreger, at de psykiske belastninger rammer bredt i alle frontfag – både i og uden for krigszoner."
    },
    {
      id: "brev-sundhedsudvalg-2025",
      title: "Brev til sundhedsudvalget",
      source: "Folketingets Sundhedsudvalg",
      date: "2025",
      linkText: "B 5 Bilag 3 Ny Tak for Din Indsats beslutningsforslag B5docx",
      url: "https://www.ft.dk/",
      category: "Dokumenter & Breve",
      description: "Officielt høringssvar og beslutningsforslag (B 5 Bilag 3) oversendt til Folketingets Sundhedsudvalg med konkrete forslag til en helhedsorienteret og tværfaglig PTSD-behandling."
    },
    {
      id: "podcast-tvaerfaglig-kamp-2025",
      title: "Podcast - Tværfaglig kamp mod PTSD",
      source: "Det bliver altid fredag! Podcast",
      date: "Juni 2025",
      linkText: "18. TAK FOR DIN INDSATS | Tvæ…–Det bliver altid fredag! – Apple Podcasts",
      url: "https://podcasts.apple.com/dk/podcast/det-bliver-altid-fredag/id1612345678",
      category: "Podcast & Webinarer",
      description: "Deltagelse i episode 18 af den populære podcast 'Det bliver altid fredag!', hvor vi diskuterer den tværfaglige indsats og nødvendigheden af hurtig, effektiv hjælp til PTSD-ramte."
    },
    {
      id: "tv2nord-hemmelige-missioner-2025",
      title: "TV2 Nord - Hemmelige missioner gav Steffen PTSD, nu hjælper han andre",
      source: "TV2 Nord",
      date: "April 2025",
      linkText: "Hemmelige missioner gav Steffen PTSD - nu vil han hjælpe andre | TV2 Nord - Nyheder og TV fra Nordjylland",
      url: "https://www.tv2nord.dk/",
      category: "Video & TV",
      description: "TV2 Nord dækker Steffens gribende historie som operativ jægersoldat, hans pludselige fald, og hvordan han i dag kanaliserer sin smerte over i at hjælpe andre gennem TFDI."
    },
    {
      id: "tv2nord-velgoerenhed-2025",
      title: "TV2 Nord – Video fra Velgørenhedsaftenen",
      source: "TV2 Nord / Facebook",
      date: "April 2025",
      linkText: "Video | Facebook",
      url: "https://www.facebook.com/takfordinindsats",
      category: "Video & TV",
      description: "Se det stemningsfulde videoindslag og de stærke taler fra vores store, succesfulde velgørenhedsaften, som blev dækket tæt af TV2 Nord."
    },
    {
      id: "webinar-behandling-ptsd-2024",
      title: "Webinar om helhedsorienteret behandling af PTSD",
      source: "TFDI & LPTSD",
      date: "November 2024",
      linkText: "Webinar om helhedsorienteret behandling af PTSD i samarbejde med TFDI & LPTSD",
      url: "https://www.youtube.com/",
      category: "Podcast & Webinarer",
      description: "Et dybdegående fagligt webinar afholdt i tæt samarbejde med Landsforeningen for PTSD (LPTSD) med fokus på internationale erfaringer og helhedsorienterede behandlingsmetoder."
    },
    {
      id: "tfdi-stoette-mc-sgb-2024",
      title: "TFDI støttede ”MC” med Stellatum Ganglion Block – SGB",
      source: "Facebook",
      date: "Oktober 2024",
      linkText: "I mørket findes der også lys🕯️♥️.. Det er... - Tak For Din Indsats | Facebook",
      url: "https://www.facebook.com/takfordinindsats",
      category: "Artikler & Nyheder",
      description: "En rørende og håbefuld beretning om, hvordan TFDI finansierede og støttede 'MC' i at modtage en SGB-behandling (Stellatum Ganglion Block), som har givet ham livet og roen tilbage."
    },
    {
      id: "olfi-ny-forening-2024",
      title: "OLFI - Ny forening vil forhindre forskelsbehandling af PTSD-ramte",
      source: "OLFI",
      date: "Oktober 2024",
      linkText: "OLFI - Ny forening vil forhindre forskelsbehandling af PTSD-ramt frontlinjepersonel",
      url: "https://olfi.dk/",
      category: "Artikler & Nyheder",
      description: "Forsvarsmediet OLFI dækker lanceringen af Tak For Din Indsats og vores mærkesag om, at støtte og behandling ikke må afhænge af, hvilken uniform man har båret."
    },
    {
      id: "olfi-halv-hjerne-2024",
      title: "OLFI - Jeg har en halv hjerne og er førtidspensionist",
      source: "OLFI",
      date: "Oktober 2024",
      linkText: "OLFI - »Jeg har en halv hjerne og er førtidspensionist, men det her er mit formål«",
      url: "https://olfi.dk/",
      category: "Artikler & Nyheder",
      description: "Et hudløst ærligt og stærkt interview i OLFI med Steffen Carlsen om overgangen fra jægersoldat til førtidspensionist, og hvordan TFDI er blevet hans nye, livsvigtige formål."
    },
    {
      id: "olfi-maerkesager-2024",
      title: "OLFI – TFDI-mærkesager",
      source: "OLFI / TFDI",
      date: "April 2024",
      linkText: "TFDI-maerkesager-April-2024-Olfi_21.10.24.pdf",
      url: "https://olfi.dk/",
      category: "Dokumenter & Breve",
      description: "Vores officielle mærkesager og politiske prioriteter præsenteret i et overskueligt dokument udgivet i samarbejde med OLFI for at sikre lige vilkår for alt frontpersonale."
    }
  ],
  news: [],
  events: [
    {
      id: "velgoerenhedsaften-utzon-2026",
      title: "Velgørenhedsaften 10. september 2026",
      shortTitle: "Velgørenhedsaften på Utzon Center",
      location: "Utzon Center i Aalborg",
      date: "10. september 2026",
      category: "Velgørenhedsaften",
      status: "Afholdt event",
      image: "/cdn-cgi/image/width=1200,quality=85,format=auto/_assets/utzon-center-velgoerenhedsaften.png",
      excerpt: "Der blev 10. september afholdt TFDI velgørenhedsaften på Utzon Center i Aalborg. Se her et par videoer fra aftenen. Alle indkomne beløb går ubeskåret til foreningens aktiviteter.",
      content: "Der blev 10. september afholdt TFDI velgørenhedsaften på Utzon Center i Aalborg. Se her et par videoer fra aftenen. Alle indkomne beløb går ubeskåret til foreningens aktiviteter.",
      videos: [
        {
          id: "video-um",
          title: "Video UM",
          subtitle: "Video fra aftenen på Utzon Center",
          src: "/_assets/video-um.mov",
          type: "video/quicktime",
          badge: "Video UM"
        },
        {
          id: "musik",
          title: "Stemningsvideo – Musik",
          subtitle: "Stemnings- og musikvideo fra velgørenhedsaftenen",
          src: "/_assets/musik-1.mp4",
          type: "video/mp4",
          badge: "Musik"
        }
      ]
    }
  ],
  cooperationPartners: [
    {
      id: "bridgerunner",
      name: "Bridgerunner",
      description: "Et aktivt fællesskab og initiativ, der bygger broer og skaber fysiske og sociale aktiviteter for veteraner og frontpersonale.",
      icon: "fa-solid fa-person-running"
    },
    {
      id: "centralforeningen-stampersonel",
      name: "Centralforeningen for stampersonel",
      description: "CS varetager faglige, lønmæssige og arbejdsmæssige interesser for militært og civilt ansatte i Forsvaret og Hjemmeværnet.",
      icon: "fa-solid fa-award"
    },
    {
      id: "cepda",
      name: "Cepda - Center for psykedelisk dannelse",
      description: "Forsknings- og oplysningscenter, der arbejder med evidensbaseret viden om psykedelisk assisteret terapi til behandling af svær PTSD og traumer.",
      icon: "fa-solid fa-brain"
    },
    {
      id: "coolunite",
      name: "Coolunite",
      description: "En velgørende fond, der støtter sårbare og sygdomsramte børn samt deres familier, og bidrager til at skabe lyspunkter i en svær hverdag.",
      icon: "fa-solid fa-hand-holding-heart"
    },
    {
      id: "danmarks-veteraner",
      name: "Danmarks Veteraner",
      description: "Danmarks største veteranforening, der arbejder for at samle og støtte alle veteraner og deres pårørende gennem lokale fællesskaber og aktiviteter.",
      icon: "fa-solid fa-users-viewfinder"
    },
    {
      id: "foa",
      name: "FOA",
      description: "Fagforening for offentligt ansatte, herunder ambulancepersonale, sygehusansatte og brandfolk, der kæmper for bedre arbejdsvilkår og anerkendelse.",
      icon: "fa-solid fa-briefcase"
    },
    {
      id: "frontline-network",
      name: "Frontline Network",
      description: "Et stærkt netværk, der understøtter frontpersonale på tværs af faggrænser med vidensdeling, ressourcer og gensidig faglig sparring.",
      icon: "fa-solid fa-network-wired"
    },
    {
      id: "hkkf",
      name: "HKKF",
      description: "Hærens Konstabel- og Korporalforening, der varetager faglige og sociale interesser for konstabler, korporaler og værnepligtige i Hæren.",
      icon: "fa-solid fa-shield-halved"
    },
    {
      id: "hod",
      name: "HOD",
      description: "Hovedorganisationen af Officerer i Danmark, der sikrer og forbedrer de faglige, økonomiske og arbejdsmæssige vilkår for officerer i Forsvaret.",
      icon: "fa-solid fa-chevron-up"
    },
    {
      id: "hprd",
      name: "HPRD",
      description: "Hovedorganisationen for Personel af Reserven i Danmark, som støtter og repræsenterer reservister på tværs af alle værn.",
      icon: "fa-solid fa-user-shield"
    },
    {
      id: "light4blue",
      name: "Light4Blue",
      description: "En støtteforening og et landsdækkende initiativ, der skaber synlighed, anerkendelse og støtte til politiet og øvrigt blåt frontpersonale.",
      icon: "fa-solid fa-lightbulb"
    },
    {
      id: "politiforbundet",
      name: "Politiforbundet",
      description: "Fagforeningen for Danmarks politiansatte, der arbejder utrætteligt for retfærdige arbejdsvilkår, sikkerhed og anerkendelse af politiets indsats.",
      icon: "fa-solid fa-building-shield"
    },
    {
      id: "the-black-flag-group",
      name: "The Black Flag Group",
      description: "Et stærkt fællesskab og netværk for veteraner og frontpersonale, der arbejder for sammenhold, opbakning og gensidig støtte.",
      icon: "fa-solid fa-flag"
    },
    {
      id: "thin-blue-line",
      name: "Thin Blue Line",
      description: "En støtteforening for tilskadekomne polititjenestemænd og deres pårørende, der yder støtte, anerkendelse og omsorg.",
      icon: "fa-solid fa-shield-heart"
    },
    {
      id: "thin-red-line",
      name: "Thin Red Line",
      description: "En dedikeret støtteforening, der arbejder for at hjælpe, anerkende og støtte brandfolk, redningspersonale og deres pårørende.",
      icon: "fa-solid fa-fire-extinguisher"
    },
    {
      id: "veteran-koordinatorer",
      name: "Veteran koordinatorer i landets kommuner",
      description: "Det kommunale netværk af koordinatorer, der sikrer en koordineret, lokal og helhedsorienteret indsats for veteraner og deres familier.",
      icon: "fa-solid fa-map-location-dot"
    },
    {
      id: "veterancenteret",
      name: "Veterancenteret",
      description: "Forsvarets centrale instans for støtte til veteraner og pårørende før, under og efter udsendelse med fokus på rehabilitering og rådgivning.",
      icon: "fa-solid fa-house-medical"
    }
  ]
};
